export default __webpack_public_path__ + "static/media/assessment_glide_4_2.73391e77.svg";